module.exports = __webpack_public_path__ + "static/democracyprep-c298b9337de085f42edad8a6aff7fa09.png";